import React, { useMemo } from "react";

const InvoicePreview = ({ formData = {}, data = {} }) => {
  const ORANGE = "#ff6a00";

  const formatMoney = (n) =>
    `${data?.currencyName}${Number(n || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  const formatDateTime = (dt) => {
    if (!dt) return "-";
    const d = new Date(dt);
    return d.toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const clientName =
    data?.clientData?.find((c) => c._id === formData.clientId)?.name ||
    formData.clientName ||
    "-";

  const branch =
    data?.branchData?.find((b) => b._id === formData.branchId) || {};

  const rows = useMemo(() => {
    return (formData.services || []).map((s, i) => ({
      idx: i + 1,
      name: s.serviceName || "-",
      basePrice: s.basePrice,
      originalBasePrice: s.originalBasePrice,
      gstAmount: s.gstValue,
      total: s.finalAmount,
      hasOffer: s.selectedOffer && s.offerDiscount > 0,
      offerName: s.selectedOffer?.name,
      offerDiscount: s.offerDiscount,
    }));
  }, [formData.services]);

  const subtotal = rows.reduce((s, r) => s + r.basePrice, 0);
  const totalGST = rows.reduce((s, r) => s + r.gstAmount, 0);
  const additionalDiscount = formData.additionalOffer?.discountPrice || 0;
  const grandTotal = formData.totalAmount || subtotal + totalGST - additionalDiscount;

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 10,
        padding: 24,
        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
      }}
    >
      {/* HEADER */}
      <div className="d-flex justify-content-between">
        <div>
          <div style={{ fontSize: 26, fontWeight: 800, color: ORANGE }}>
            INVOICE
          </div>
          <div className="fw-semibold">{branch.name}</div>
          <div style={{ fontSize: 13 }}>
            {branch.building} {branch.street}
          </div>
          <div style={{ fontSize: 13 }}>
            {branch.city}, {branch.stateName} {branch.zipCode}
          </div>
          <div style={{ fontSize: 13 }}>
            Phone: {branch.mobileNumber}
          </div>
        </div>

        <div className="text-end">
          <div style={{ fontSize: 12 }}>Invoice Date</div>
          <div className="fw-semibold">
            {new Date().toLocaleDateString("en-US")}
          </div>
        </div>
      </div>

      <hr />

      {/* BILL TO */}
      <div>
        <div style={{ fontSize: 12 }} className="text-muted">
          BILL TO
        </div>
        <div className="fw-bold">{clientName}</div>
        <div style={{ fontSize: 13 }}>
          Branch: {branch.name}
        </div>
        <div style={{ fontSize: 13 }}>
          Service Date: {formatDateTime(formData.startDateTime)}
        </div>
      </div>

      {/* SERVICES TABLE */}
      <div className="table-responsive mt-4">
        <table className="table align-middle table table-bordered">
          <thead style={{ background: "#ffe9d6" }}>
            <tr>
              <th>#</th>
              <th>Service</th>
              <th className="text-end">Base Price</th>
              <th className="text-end">GST</th>
              <th className="text-end">Total</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((r) => (
              <tr key={r.idx}>
                <td>{r.idx}</td>

                {/* SERVICE NAME + OFFER */}
                <td>
                  <div className="fw-semibold">{r.name}</div>

                  {/* {r.hasOffer && (
                    <>
                      <div style={{ fontSize: 12, color: "#ff4d4f" }}>
                        Discount: ₹{r.offerDiscount.toFixed(2)}
                      </div>
                      <div style={{ fontSize: 11, color: "#6b7280" }}>
                        Offer: {r.offerName}
                      </div>
                    </>
                  )} */}
                </td>

                {/* BASE PRICE */}
                <td className="text-end">
                  {/* {r.hasOffer && (
                    <div
                      style={{
                        textDecoration: "line-through",
                        fontSize: 12,
                        color: "#9ca3af",
                      }}
                    >
                      {formatMoney(r.originalBasePrice)}
                    </div>
                  )} */}
                  <div className="fw-semibold">
                    {formatMoney(r.basePrice)}
                  </div>
                </td>

                {/* GST */}
                <td className="text-end">{formatMoney(r.gstAmount)}</td>

                {/* TOTAL */}
                <td className="text-end fw-bold">
                  {formatMoney(r.total)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* SUMMARY */}
      <div className="d-flex justify-content-end mt-3">
        <div style={{ width: 360 }}>
          <div className="d-flex justify-content-between">
            <span className="fw-bold">Subtotal</span>
            <span>{formatMoney(subtotal)}</span>
          </div>

          <div className="d-flex justify-content-between pb-2">
            <span className="fw-bold">Total GST</span>
            <span>{formatMoney(totalGST)}</span>
          </div>

          {additionalDiscount > 0 && (
            <div className="d-flex justify-content-between border-top pt-2">
              <span>Additional Discount</span>
              <span>- {formatMoney(additionalDiscount)}</span>
            </div>
          )}

          <div
            className="d-flex justify-content-between mt-2 p-3"
            style={{
              background: "#fff3ea",
              borderRadius: 6,
              fontWeight: 700,
            }}
          >
            <span>Grand Total</span>
            <span style={{ color: ORANGE }}>
              {formatMoney(grandTotal)}
            </span>
          </div>
        </div>
      </div>

      <hr />

      {/* FOOTER */}
      <div className="text-center">
        <div className="fw-semibold">Thank you for your visit!</div>
        <div style={{ fontSize: 12 }} className="text-muted">
          For any queries, please contact {branch.name}
        </div>
      </div>
    </div>
  );
};

export default InvoicePreview;
